var everettFontFamily = [
    "Everett",
    "Roboto",
    "Helvetica Neue",
    "Arial",
    "sans-serif",
].join(",");
var tobiasFontFamily = ["Tobias", "Times New Roman", "Georgia", "serif"].join(",");
export var typography = {
    h1: {
        fontSize: 36,
        fontWeight: 600,
        fontFamily: tobiasFontFamily,
    },
    h2: {
        fontSize: 30,
        fontWeight: 600,
        fontFamily: tobiasFontFamily,
    },
    h3: {
        fontSize: 26,
        fontWeight: 600,
        fontFamily: tobiasFontFamily,
    },
    h4: {
        fontSize: 26,
        fontWeight: 500,
        fontFamily: everettFontFamily,
    },
    h5: {
        fontSize: 24,
        fontWeight: 500,
        fontFamily: everettFontFamily,
    },
    h6: {
        fontSize: 20,
        fontWeight: 500,
        fontFamily: everettFontFamily,
    },
    body1: {
        fontSize: 16,
        fontFamily: everettFontFamily,
    },
    body2: {
        fontSize: 14,
        fontFamily: everettFontFamily,
    },
    button: {
        fontFamily: everettFontFamily,
    },
    caption: {
        fontSize: 12,
        fontFamily: everettFontFamily,
    },
    overline: {
        fontFamily: everettFontFamily,
    },
    subtitle1: {
        fontFamily: everettFontFamily,
    },
    subtitle2: {
        fontFamily: everettFontFamily,
    },
};
